export interface SlotManifest {
  name: string;
  type: 'text' | 'image' | 'icon';
  required?: boolean;
  max_chars?: number;
  ejemplo?: string;
  opciones?: string[];
}

export interface PlantillaManifest {
  id: string;
  nombre: string;
  categoria: string;
  formato: string;
  industrias: string[];
  objetivo?: string;
  slots: SlotManifest[];
  colores_usados?: string[];
  notas?: string;
  /** Plantillas de temporada (categoria "festivo"): slug de la fecha, p. ej. "navidad". */
  ocasion?: string;
  ocasion_nombre?: string;
  fecha_referencia?: string;
  layout?: string;
  /** Colores con los que abre la plantilla. "Usar mi marca" los cambia por los de la empresa. */
  paleta_temporada?: BrandPalette;
}

export interface PlantillaFuente {
  id: string;
  formato: string;
  manifest: PlantillaManifest;
  html: string;
}

export interface BrandPalette {
  '--brand-primary': string;
  '--brand-secondary': string;
  '--brand-accent': string;
  '--brand-bg': string;
  '--brand-text': string;
  '--brand-on-primary': string;
  '--brand-on-secondary': string;
  '--brand-on-accent': string;
}

export interface AjusteImagen {
  zoom: number;
  x: number;
  y: number;
}

export const AJUSTE_IMAGEN_INICIAL: AjusteImagen = { zoom: 1, x: 50, y: 50 };

export interface EmpresaMarcaInput {
  nombre?: string;
  telefono?: string;
  slug?: string;
  logo?: string;
  logo_url?: string;
  instagram_url?: string | null;
  configuracion?: {
    branding?: {
      logo?: string;
      nombreEmpresa?: string;
      colores?: { primario?: string; secundario?: string; acento?: string };
    };
    contactoPublico?: { whatsappBusiness?: string };
  } | null;
}
